import { Component, Input } from '@angular/core';
import { Ticket, TicketStatus } from 'src/app/models/ticket/ticket.model';

@Component({
  selector: 'app-ticket-detail-header',
  templateUrl: './ticket-detail-header.component.html',
  standalone: false,
})
export class TicketDetailHeaderComponent {
  @Input() ticket: Ticket;

  @Input() browserSize: string;

  TicketStatus = TicketStatus;
}
